export const PROJECT_INQUIRY_URL = '/#contact';
export const KAKAO_TALK_URL = 'http://pf.kakao.com/_rRJrn';
